import React, { ReactNode } from 'react';
import clsx from 'classnames';

type TypographyProps = {
  variant?: keyof typeof variantClasses;
  className?: string;
  children: React.ReactNode;
  color?: 'primary' | 'secondary';
  font?: 'medium' | 'bold' | 'light';
};

const variantClasses: Record<string, string> = {
  h1: 'text-6xl font-bold',
  h2: 'text-4xl font-semibold',
  h3: 'text-3xl font-semibold',
  h4: 'text-2xl font-medium',
  h5: 'text-xl font-medium',
  h6: 'text-base font-medium',
  p: 'text-base',
  span: 'text-base',
  caption: 'text-sm ',
};

export const Typography: React.FC<TypographyProps> = ({
  variant = 'p',
  className,
  color,
  children,
  font,
  ...props
}) => {
  const Component = variant as keyof JSX.IntrinsicElements as React.ElementType;
  return (
    <Component
      className={clsx(
        variantClasses[variant],
        {
          'text-primary': (props as any).color === 'primary',
          'text-secondary': (props as any).color === 'secondary',
        },
        {
          'howio-font-md': font === 'medium',
        },
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

export const H1 = (props: TypographyProps) => <Typography font="medium" variant="h1" {...props} />;
export const H2 = (props: TypographyProps) => <Typography font="medium" variant="h2" {...props} />;
export const H3 = (props: TypographyProps) => <Typography variant="h3" {...props} />;
export const H4 = (props: TypographyProps) => <Typography variant="h4" {...props} />;
export const H5 = (props: TypographyProps) => <Typography variant="h5" {...props} />;
export const H6 = (props: TypographyProps) => <Typography variant="h6" {...props} />;
export const P = (props: TypographyProps) => <Typography variant="p" {...props} />;
export const Span = (props: TypographyProps) => <Typography variant="span" {...props} />;
export const Caption = (props: TypographyProps) => <Typography variant="caption" {...props} />;
